import React from "react";
import { Button } from "@/components/ui/button";
import { CalendarBlank, ArrowCounterClockwise } from "@phosphor-icons/react";

export const firstOfMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`;
};
export const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export function buildDateQuery(range) {
  const p = new URLSearchParams();
  if (range?.from) p.set("date_from", range.from);
  if (range?.to) p.set("date_to", range.to);
  const s = p.toString();
  return s ? `?${s}` : "";
}

export function DateRangeFilter({ range, onChange, testidPrefix = "date-range" }) {
  const setThisMonth = () => onChange({ from: firstOfMonth(), to: todayStr() });
  const clear = () => onChange({ from: "", to: "" });
  const active = !!(range.from || range.to);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testidPrefix}-filter`}>
      <CalendarBlank size={15} className="text-slate-400 shrink-0" />
      <input type="date" value={range.from}
             onChange={(e) => onChange({ ...range, from: e.target.value })}
             className="h-8 border border-slate-300 rounded px-2 text-xs bg-white"
             data-testid={`${testidPrefix}-from`} />
      <span className="text-xs text-slate-400">s/d</span>
      <input type="date" value={range.to}
             onChange={(e) => onChange({ ...range, to: e.target.value })}
             className="h-8 border border-slate-300 rounded px-2 text-xs bg-white"
             data-testid={`${testidPrefix}-to`} />
      <Button variant="outline" size="sm" className="h-8 text-xs" onClick={setThisMonth}
              data-testid={`${testidPrefix}-this-month`}>Bulan Ini</Button>
      {active && (
        <Button variant="ghost" size="sm" className="h-8 text-xs text-slate-500" onClick={clear}
                data-testid={`${testidPrefix}-clear`}>
          <ArrowCounterClockwise size={12} className="mr-1" />Semua
        </Button>
      )}
    </div>
  );
}
